// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../css-loader/index.js!./vue-popper.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../vue-style-loader/lib/addStylesClient.js")("22f91ced", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-popperjs/dist/css/vue-popper.css
// module id = 32
// module chunks = 0